import React, { useState } from 'react'
import StatusBadge from '../../components/StatusBadge'

// Field labels for display
const FIELD_LABELS = {
  nome: 'Nome',
  no_imovel: 'Número do imóvel',
  data_levantamento: 'Data do levantamento',
  tipo_de_uso: 'Tipo de uso (IPTU)',
  tipo_de_terreno: 'Tipo de terreno',
  valor_venal_lote: 'Valor venal lote',
  valor_venal_edificio: 'Valor venal edifício',
  area_construida: 'Área construída (m²)',
  area_do_terreno: 'Área do terreno (m²)',
  estacionamento_meio_fio: 'Vagas meio fio',
  estacionamento_zona_azul: 'Zona azul',
  estacionamento_recuo: 'Vagas recuo',
  estacionamento_garagem: 'Vagas garagem',
  estacionamento_moto: 'Vagas moto',
  ponto_taxi: 'Ponto de táxi',
  fachada_ativa: 'Fachada ativa',
  fruicao_publica: 'Fruição pública',
  cultura_comercial_diversificada: 'Cultura comercial',
  uso_terreo: 'Uso térreo',
  entrada_de_veiculos: 'Entrada de veículos',
  ponto_de_onibus: 'Ponto de ônibus',
  uso_superior: 'Uso pavimentos superiores',
  testada: 'Testada',
  gabarito: 'Gabarito',
  idade_aproximada: 'Idade aproximada',
  edificacao_tombada: 'Edificação tombada',
  arborizacao: 'Arborização',
  protecao_sol_chuva: 'Proteção sol/chuva',
  ambulantes: 'Ambulantes',
  conservacao_fachada: 'Conservação fachada',
  conservacao_calcada: 'Conservação calçada',
  degrau_entre_calcadas: 'Degrau entre calçadas',
  permanencia_na_calcada: 'Permanência na calçada',
  muro: 'Muro ou fachada cega',
  paraciclo: 'Paraciclo',
  alugar_ou_vender: 'Alugar ou vender',
  horario_comercial: 'Horário comercial',
  fim_de_semana: 'Fim de semana',
  apos_19: 'Após 19h'
}

// Fields to exclude from display
const EXCLUDED_FIELDS = ['id', 'lote_id', 'created_at', 'updated_at']

function formatValue(value) {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  if (typeof value === 'boolean') {
    return value ? 'Sim' : 'Não'
  }
  return String(value)
}

export default function VarejoInfo({ varejo, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  // Get all displayable fields
  const fields = Object.entries(varejo).filter(
    ([key]) => !EXCLUDED_FIELDS.includes(key)
  )

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden mb-2">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors text-left"
      >
        <div className="flex items-center gap-3">
          <span className="font-medium text-gray-900">
            {varejo.nome || `Varejo #${varejo.id}`}
          </span>
          {varejo.status && <StatusBadge status={varejo.status} />}
        </div>
        <svg
          className={`w-5 h-5 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="p-4 border-t border-gray-200 bg-white">
          <div className="grid sm:grid-cols-2 gap-2">
            {fields.map(([key, value]) => (
              <div key={key} className="flex gap-2 text-sm">
                <span className="font-medium text-gray-600">
                  {FIELD_LABELS[key] || key}:
                </span>
                <span className="text-gray-800">{formatValue(value)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
